import api from '../api';
import { API_URL } from '../config';

// GET all career records for an employee
export const getEmployeeCareers = async (employeeId) => {
  try {
    const response = await api.get(`${API_URL}/careers/employee/${employeeId}`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching careers for employee ${employeeId}:`, error);
    throw new Error(error.response?.data?.message || 'Failed to fetch career records');
  }
};

// GET all career records (globally)
export const getAllCareers = async () => {
  try {
    const response = await api.get(`${API_URL}/careers`);
    return response.data;
  } catch (error) {
    console.error('Error fetching all careers:', error);
    throw new Error(error.response?.data?.message || 'Failed to fetch all career records');
  }
};

// POST create a new career record for an employee
export const createEmployeeCareer = async (employeeId, careerData) => {
  try {
    const response = await api.post(`${API_URL}/careers/employee/${employeeId}`, careerData);
    return response.data;     
  } catch (error) {
    console.error(`Error creating career record for employee ${employeeId}:`, error);
    throw new Error(error.response?.data?.message || 'Failed to create career record');
  }
};

// PUT update a career record
export const updateEmployeeCareer = async (employeeId, careerId, careerData) => {
  try {
    const response = await api.put(`${API_URL}/careers/employee/${employeeId}/${careerId}`, careerData);
    return response.data;
  } catch (error) {
    console.error(`Error updating career record ${careerId}:`, error);
    throw new Error(error.response?.data?.message || 'Failed to update career record');
  }
};

// DELETE a career record
export const deleteEmployeeCareer = async (employeeId, careerId) => {
  try {
    await api.delete(`${API_URL}/careers/employee/${employeeId}/${careerId}`);
  } catch (error) {
    console.error(`Error deleting career record ${careerId}:`, error);
    throw new Error(error.response?.data?.message || 'Failed to delete career record');
  }
};

// GET current user's career records
export const getMyCareer = async () => {
  try {
    const response = await api.get(`${API_URL}/careers/my-career`);
    return response.data;
  } catch (error) {
    console.error('Error fetching current user career:', error);
    throw new Error(error.response?.data?.message || 'Failed to fetch your career records');
  }
};

// POST create a career record for yourself
export const createMyCareer = async (careerData) => {
  try {
    const response = await api.post(`${API_URL}/careers`, careerData);
    return response.data;
  } catch (error) {
    console.error('Error creating career record:', error);
    throw new Error(error.response?.data?.message || 'Failed to create career record');
  }
};

// PUT update your own career record
export const updateMyCareer = async (careerId, careerData) => {
  try {
    const response = await api.put(`${API_URL}/careers/${careerId}`, careerData);
    return response.data;
  } catch (error) {
    console.error(`Error updating career record ${careerId}:`, error);
    throw new Error(error.response?.data?.message || 'Failed to update career record');
  }
};

// DELETE your own career record
export const deleteMyCareer = async (careerId) => {
  try {
    await api.delete(`${API_URL}/careers/${careerId}`);
  } catch (error) {
    console.error(`Error deleting career record ${careerId}:`, error);
    throw new Error(error.response?.data?.message || 'Failed to delete career record');
  }
};
